import React, { useMemo, useState } from 'react'
import './style.scss'
import '../search-customer/search-customer.scss'
import Modal from '../../components/common/modal/Modal'
import SinglePage from '../../components/common/page/SinglePage'
import SpinWithMessage from '../../components/common/spinners/SpinWithMessage'
import { customerAxios } from '../../config/axios'
import toast from 'react-hot-toast'
import NormalInput from '../../components/common/inputs/NormalInput'
import SelectInput from '../../components/common/inputs/SelectInput'
import { BiLoaderAlt } from 'react-icons/bi'
import { FcDeleteDatabase, FcSearch } from 'react-icons/fc'
import { FaWhatsapp } from 'react-icons/fa6'
import { IoCheckmarkDoneCircleOutline, IoCheckmarkCircleOutline, IoCloseCircleOutline, IoTimeOutline } from 'react-icons/io5'
import { convertIsoToAmPm, formateDateToDayText } from '../../assets/javascript/formate-functions'
import WaSendReport from '../../components/user/wa-send-report/WaSendReport'
import { waAccounts } from '../../assets/javascript/wa_config'

const WaSendStatusList = () => {
    const [modal, setModal] = useState({ status: false })
    const [loading, setLoading] = useState('fetch')
    const [data, setData] = useState([])
    const [form, setForm] = useState({ asot_types: [], key: '' })
    const [ifSearch, setIfSearch] = useState(false)
    const [templateNames, setTemplateNames] = useState([])
    const [contentLimit, setContentLimit] = useState({ page: 1, limit: 50 })
    const [seeMore, setSeeMore] = useState(true)

    const openModal = (item) => {
        setModal({
            status: true, title: 'Message Details', content: <WaSendReport data={item} />
        })
    }

    const messageTypes = [
        { option: 'Incoming', value: 'incoming' },
        { option: 'Out : Service', value: 'service' },
        { option: 'Out : Template', value: 'template' },
    ]

    const handleChange = (e) => {

        if (e.target.name === 'phone_number_id') {
            const account = waAccounts.find((a) => a.phone_number_id === e.target.value)

            setForm({
                ...form,
                [e.target.name]: e.target.value,
                waba_id: account?.waba_id
            })

            return;
        }

        setForm({
            ...form,
            [e.target.name]: e.target.value
        })
    }

    const fetchData = (page, limit, newFetch) => {
        setLoading('fetch')
        customerAxios.get('communication/whatsapp/send-report',
            {
                params: {
                    page: page,
                    limit: limit,
                    start_date: form.start_date || null,
                    end_date: form.end_date || null,
                    message_type: form.message_type || null,
                    template_name: form.template_name || null,
                    phone_number_id: form.phone_number_id || null,
                    contact_number: form?.contact_number || null
                }
            })
            .then((response) => {
                setIfSearch(true)
                if (newFetch) {
                    setData(response.data)
                } else {
                    setData([...data, ...response.data])
                }

                if (response.data.length < limit) {
                    setSeeMore(false)
                } else {
                    setSeeMore(true)
                }
                setLoading('')
            }).catch((error) => {
                toast.error(error.message)
                setLoading('')
            })
    }

    const handleApply = (e) => {
        e.preventDefault();
        setContentLimit({ ...contentLimit, page: 1 })
        fetchData(1, contentLimit.limit, 'newFetch')
    }

    useMemo(async () => {
        // fetch template name list

        if (form?.waba_id) {
            const { data } = await customerAxios.get(`/communication/whatsapp/${form?.waba_id}/templates`)
            setTemplateNames(data)
        } else {
            setTemplateNames([])
        }

    }, [form?.waba_id])

    return (
        <div className="wa-send-report-page-div">
            <Modal modal={modal} setModal={setModal} />
            <SinglePage titleArray={['WhatsApp Message Send Status']}>
                <div className="search-border-div">
                    <div className="filter-border-div">
                        <form action="" onSubmit={handleApply} >
                            <div className="search-section">
                                <h5>Date range</h5>
                                <NormalInput label='From Date *' type={'date'} name='start_date' value={form.start_date} onChangeFun={handleChange} max={form?.end_date} />
                                <NormalInput label='End Date *' type={'date'} name='end_date' value={form.end_date} onChangeFun={handleChange} min={form?.start_date} />
                            </div>
                            <div className="search-section">
                                <h5>WABA Account</h5>
                                <SelectInput label='Mobile Number' name='phone_number_id' values={waAccounts?.map((a) => ({ option: a.business_name, value: a.phone_number_id }))}
                                    onChangeFun={handleChange} firstOption={{ option: 'Choose...', value: '' }} />
                            </div>

                            <div className="search-section">
                                <h5>Message type</h5>
                                <SelectInput label='Message type' name='message_type' values={messageTypes} onChangeFun={handleChange}
                                    firstOption={{ option: 'Choose...', value: '' }} isRequired={false} />

                                {form?.message_type === 'template' &&
                                    <SelectInput label='Template name' name='template_name' values={(templateNames || [])?.map((a) => ({ option: a, value: a, selected: a === form.template_name }))} onChangeFun={handleChange}
                                        firstOption={{ option: 'Choose...', value: '' }} />
                                }
                            </div>

                            {/* <div className="search-section">
                                <h5>Whatsapp number (Send to)</h5>
                                <NormalInput type={'number'} label='Enter with country code' name='contact_number' value={form.contact_number} onChangeFun={handleChange} isRequired={false}
                                    placeholder={'Ex : 919876543210'} />
                            </div> */}

                            {(form?.waba_id) && <div className="button-div">
                                <button type='submit'>{loading === 'filter' ? <span className='loading-icon'><BiLoaderAlt /></span> : "Filter"}</button>
                            </div>}

                        </form>
                    </div>
                    <div className="result-div">
                        {data?.[0] ?
                            <div className='result-list'>
                                {data?.map((item) => {
                                    const lastStatus = item?.status_flow?.[item?.status_flow?.length - 1] || null;
                                    const waAccount = waAccounts?.find((a) => a.phone_number_id === item?.phone_number_id)
                                    return <div key={item?.uuid} className="item" onClick={() => openModal(item)}>
                                        <div className="s-one">
                                            <h4>{item?.message_type === 'template' ? item?.template : item?.message_type}</h4>
                                            <p>{waAccount?.business_name}</p>
                                        </div>
                                        <div className="s-two">
                                            <p>{item?.direction === 'incoming' ? 'From' : 'Send to'}</p>
                                            <div className="number">
                                                <p>{item?.send_to}</p>
                                                {(lastStatus && lastStatus?.status !== 'failed') && <FaWhatsapp />}
                                            </div>
                                        </div>
                                        <div className="s-three ">
                                            {(item?.message_status === 'sent' && !lastStatus) && <>
                                                <span className='pending'>
                                                    <IoTimeOutline />
                                                    <h4>Pending</h4>
                                                </span>
                                                <p>{convertIsoToAmPm(item?.time)}, {formateDateToDayText(item?.time)}</p>
                                            </>}
                                            {(item?.message_status !== 'sent' && !lastStatus) && <>
                                                <span className='failed'>
                                                    <IoTimeOutline />
                                                    <h4>Failed</h4>
                                                </span>
                                                <p>{convertIsoToAmPm(item?.time)}, {formateDateToDayText(item?.time)}</p>
                                            </>}
                                            {lastStatus && <>
                                                <span className={lastStatus?.status}>
                                                    {lastStatus?.status === 'read' ? < IoCheckmarkDoneCircleOutline />
                                                        : lastStatus?.status === 'delivered' ? <IoCheckmarkDoneCircleOutline />
                                                            : lastStatus?.status === 'sent' ? <IoCheckmarkCircleOutline />
                                                                : lastStatus?.status === 'failed' ? <IoCloseCircleOutline /> : ''}
                                                    <h4>{lastStatus?.status}</h4>
                                                </span>
                                                <p>{convertIsoToAmPm(item?.time)}, {formateDateToDayText(item?.time)}</p>
                                            </>}
                                        </div>
                                    </div>
                                })}

                                {seeMore && <div className="button-div" style={{ justifyContent: 'center', marginTop: '10px' }}>
                                    <button onClick={() => {
                                        const newPage = contentLimit.page + 1
                                        setContentLimit({ ...contentLimit, page: newPage })
                                        fetchData(newPage, contentLimit.limit)
                                    }} >{loading === 'fetch' ? <span className='loading-icon'><BiLoaderAlt /></span> : "See More"}</button>
                                </div>}
                            </div>
                            : <>
                                <SpinWithMessage height={'300px'} spin={false} message={ifSearch ? 'No matched data' : 'Search to see result'} icon={ifSearch ? <FcDeleteDatabase /> : <FcSearch />} />
                            </>}
                    </div>
                </div>
            </SinglePage>
        </div>
    )
}

export default WaSendStatusList